module.exports = __webpack_public_path__ + "static/media/img_kuorong@2x.abb14c2f.png";